import { app } from 'config';
import i18n from 'i18n';

export const getArchivalOrDefaultDateRange = canUnarchive =>
  canUnarchive ? app(i18n.t).common.search.minPastValue.archive : app(i18n.t).common.search.minPastValue.default;
